/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import './settings';
import * as Sentry from '@sentry/react';
import {polyfill} from "seamless-scroll-polyfill";
import {getSetting, IndexedObject} from '@dvrd/dvr-controls';
import IDate from '@dvrd/idate';
import {setDeviceId} from "./utils";
import {addLocale, locale} from 'primereact/api';

declare global {
    interface Window {
        log: Function;
        mode: string;
        settings: IndexedObject<any>;
        modeSettings: { [index: string]: any };
        allowCookies: boolean;
        dataLayer: any;
        gtag?: Function;
        onSignInGoogle: Function;
        unlayer: any;
        Beacon: Function;
        Chart: any;
        version: string;
    }
}

const sentryUrl = getSetting('sentryUrl');
if (sentryUrl?.length) {
    const version = `bolmate@${window.version}`;
    Sentry.init({
        dsn: sentryUrl,
        release: version,
        ignoreErrors: [
            'Error: ResizeObserver loop completed with undelivered notifications.',
            'AbortError: Fetch is aborted',
            'TypeError: Failed to fetch',
        ]
    });
}

setDeviceId();
polyfill();
IDate.setLocale('nl-NL');
addLocale('nl', {
    accept: 'Accepteren', addRule: 'Filter toevoegen', apply: 'Toepassen', cancel: 'Annuleren', matchAll: 'Alle',
    contains: 'Bevat', notContains: 'Bevat niet', clear: 'Wissen', startsWith: 'Begint met', endsWith: 'Eindigt met',
    matchAny: 'Match elke', equals: 'Gelijk aan', notEquals: 'Niet gelijk aan', gt: 'Meer dan',
    gte: 'Meer of gelijk aan', lt: 'Minder dan', lte: 'Minder of gelijk aan',
});
locale('nl');